// Theme configuration for switchable design system
export const themes = {
    default: {
        name: 'Futuristic Ultra',
        // Enhanced multi-layer gradient for epic futuristic feel
        gradient: 'linear-gradient(135deg, #00ffff 0%, #0066ff 20%, #ff00ff 40%, #ff0066 60%, #ed521f 80%, #ff6b35 100%)',
        colors: {
            // Vibrant futuristic colors instead of dull gray
            primary: 'linear-gradient(145deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',     // Deep space gradient
            secondary: 'linear-gradient(145deg, #0f3460 0%, #16213e 50%, #1a1a2e 100%)',  // Reverse gradient
            accent: '#00ffff',          // Bright cyan accent
            neon: '#ff00ff',            // Neon magenta
            text: '#ffffff',
            inputText: '#ffffff',
            // Special glow colors
            glowCyan: '#00ffff',
            glowMagenta: '#ff00ff',
            glowOrange: '#ed521f'
        },
        effects: {
            // Premium shadow and glow effects
            primaryShadow: '0 8px 32px rgba(0, 255, 255, 0.3), 0 4px 16px rgba(255, 0, 255, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
            secondaryShadow: '0 6px 24px rgba(255, 0, 255, 0.4), 0 3px 12px rgba(0, 255, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
            inputGlow: '0 0 20px rgba(0, 255, 255, 0.4), 0 0 40px rgba(255, 0, 255, 0.2), inset 0 2px 4px rgba(0, 0, 0, 0.3)',
            buttonGlow: '0 4px 20px rgba(255, 0, 255, 0.5), 0 0 30px rgba(0, 255, 255, 0.3)',
            avatarGlow: '0 0 15px rgba(0, 255, 255, 0.6), 0 0 25px rgba(255, 0, 255, 0.4)',
            textGlow: '0 0 10px rgba(0, 255, 255, 0.8), 0 0 20px rgba(255, 0, 255, 0.4)',
            // Border effects
            neonBorder: '1px solid rgba(0, 255, 255, 0.5)',
            magentaBorder: '1px solid rgba(255, 0, 255, 0.5)',
            // Background effects
            containerBg: 'linear-gradient(135deg, rgba(26, 26, 46, 0.9) 0%, rgba(22, 33, 62, 0.95) 50%, rgba(15, 52, 96, 0.9) 100%)'
        },
        layout: {
            borderRadius: '18px',
            avatarRadius: '12px',       // Larger for more presence
            selectRadius: '18px'
        },
        typography: {
            fontFamily: 'Arial, sans-serif',
            headerSize: '18px',         // Keep original size for iframe compatibility
            bodySize: '15px'            // Match original backup size
        },
        background: null // No background image
    },
    americanpatriot: {
        name: 'American Patriot Ultra',
        // Enhanced multi-layer patriotic gradient for epic American feel
        gradient: 'linear-gradient(135deg, #B22234 0%, #DC143C 20%, #FFFFFF 40%, #F0F8FF 60%, #3C3B6E 80%, #002868 100%)',
        colors: {
            // Vibrant patriotic colors with gradient backgrounds
            primary: 'linear-gradient(145deg, #1a237e 0%, #3C3B6E 50%, #002868 100%)',     // Deep flag blue gradient
            secondary: 'linear-gradient(145deg, #B22234 0%, #DC143C 50%, #8B0000 100%)',   // Deep flag red gradient
            accent: '#DC143C',          // Bright red accent
            neon: '#3C3B6E',            // Patriotic blue
            text: '#ffffff',
            inputText: '#ffffff',
            // Special glow colors
            glowRed: '#DC143C',
            glowBlue: '#3C3B6E',
            glowWhite: '#FFFFFF',
            starGold: '#FFD700'         // Gold for star accents
        },
        effects: {
            // Premium patriotic shadow and glow effects
            primaryShadow: '0 8px 32px rgba(220, 20, 60, 0.3), 0 4px 16px rgba(60, 59, 110, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
            secondaryShadow: '0 6px 24px rgba(60, 59, 110, 0.4), 0 3px 12px rgba(220, 20, 60, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
            inputGlow: '0 0 20px rgba(220, 20, 60, 0.4), 0 0 40px rgba(60, 59, 110, 0.2), inset 0 2px 4px rgba(0, 0, 0, 0.3)',
            // Enhanced patriotic button effects with flag-inspired glow
            buttonGlow: '0 6px 25px rgba(178, 34, 52, 0.4), 0 3px 15px rgba(60, 59, 110, 0.3), 0 1px 8px rgba(255, 255, 255, 0.2), inset 0 1px 2px rgba(255, 255, 255, 0.3)',
            avatarGlow: '0 0 15px rgba(220, 20, 60, 0.6), 0 0 25px rgba(60, 59, 110, 0.4)',
            textGlow: '0 0 10px rgba(220, 20, 60, 0.8), 0 0 20px rgba(60, 59, 110, 0.4)',
            // Border effects with patriotic flair
            neonBorder: '1px solid rgba(220, 20, 60, 0.5)',
            patriotBorder: '2px solid rgba(255, 255, 255, 0.3)',
            // Background effects
            containerBg: 'linear-gradient(135deg, rgba(26, 35, 126, 0.9) 0%, rgba(60, 59, 110, 0.95) 50%, rgba(178, 34, 52, 0.9) 100%)'
        },
        layout: {
            borderRadius: '18px',       // Match enhanced default
            avatarRadius: '12px',       // Larger for more presence (same as default)
            selectRadius: '18px'        // Match enhanced default
        },
        typography: {
            fontFamily: 'Arial, sans-serif',
            headerSize: '18px',         // Keep original size for iframe compatibility
            bodySize: '15px'            // Match original backup size
        },
        background: '../../assets/themes/americanpatriot/flag_background.jpg',
        special: {
            // Keep existing patriotic special effects for backward compatibility
            starBorder: true,
            flagStripes: false,         // Removed - looked like browser loading bar
            goldAccents: true,
            shadowEffect: true,
            buttonGradient: 'linear-gradient(45deg, #B22234 0%, #FFFFFF 50%, #3C3B6E 100%)',
            inputGradient: 'linear-gradient(180deg, #1a237e 0%, #283593 100%)',
            // Stunning red, white, and blue header gradient for patriotic theme
            headerGradient: 'linear-gradient(90deg, #B22234 0%, #DC143C 15%, #FFFFFF 30%, #F0F8FF 45%, #FFFFFF 55%, #F0F8FF 70%, #3C3B6E 85%, #002868 100%)'
        }
    }
};